export default __webpack_public_path__ + "static/media/Bridget Watson.03542054.jpg";